import { ActiveStream, FamilyStreams, GameInfo } from "../FamilyStreams";
import { MockStream } from "./MockStream";
export class MockActiveStream implements ActiveStream {
  public streamId = "xxx";
  public game: GameInfo = {
    id: "xx",
    image: "image",
    name: "name",
  };
  stream = new MockStream();
  user = "xxx";
}
export class MockFamilyStreams implements FamilyStreams {}
